import { ShareProvider } from './share-provider.enum'

export class ShareButton {

  constructor(public provider: ShareProvider,
    public template: string,
    public classes: string) {

  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/social-share/shared/share-button.class.ts